/* Mr Mattress: Bed Option switch between a mattress product and its Base Set sister product.
   The sister product's variants are listed in a JSON script inside the control, so nothing is fetched.
   Choosing the other value goes to the sister product with the same size and length selected (?variant=).
   The theme's own variant picker never sees these changes (they are stopped in the capture phase). */
(function () {
  'use strict';
  if (window.__mmBedOption) return;
  window.__mmBedOption = true;

  function dataFor(root) {
    var el = root.querySelector('script[data-mm-bed-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function currentVariantId(data) {
    var q = new URL(window.location.href).searchParams.get('variant');
    return q || String(data.cur);
  }

  function key(v) { return v.o.join('|'); }

  function showNote(root, text) {
    var note = root.querySelector('[data-mm-bed-note]');
    if (!note) return;
    note.textContent = text;
    note.hidden = !text;
  }

  function restore(root, data) {
    var sel = root.querySelector('[data-mm-bed-select]');
    if (sel) sel.value = data.self;
    [].forEach.call(root.querySelectorAll('[data-mm-bed-radio]'), function (r) { r.checked = r.value === data.self; });
  }

  function choose(root, chosen) {
    var data = dataFor(root);
    if (!data || chosen === data.self) return;
    var vid = currentVariantId(data);
    var cur = null, i;
    for (i = 0; i < data.selfV.length; i++) { if (String(data.selfV[i].id) === String(vid)) { cur = data.selfV[i]; break; } }
    if (!cur) { for (i = 0; i < data.selfV.length; i++) { if (data.selfV[i].id === data.cur) { cur = data.selfV[i]; break; } } }
    var target = null;
    if (cur) { for (i = 0; i < data.otherV.length; i++) { if (key(data.otherV[i]) === key(cur)) { target = data.otherV[i]; break; } } }
    if (!target) {
      restore(root, data);
      showNote(root, 'The ' + chosen + ' is not available in this size.');
      return;
    }
    showNote(root, '');
    var u = new URL(data.sisterUrl, window.location.origin);
    new URL(window.location.href).searchParams.forEach(function (val, k) { if (k !== 'variant') u.searchParams.set(k, val); });
    u.searchParams.set('variant', String(target.id));
    u.hash = 'mm-bed';
    window.location.assign(u.toString());
  }

  /* capture phase on document: runs before the variant picker's own change listener */
  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var root = t.closest('[data-mm-bed]');
    if (!root) return;
    ev.stopPropagation();
    if (t.matches('[data-mm-bed-select]')) choose(root, t.value);
    else if (t.matches('[data-mm-bed-radio]') && t.checked) choose(root, t.value);
  }, true);

  /* back button / bfcache: show the value that matches this page again */
  window.addEventListener('pageshow', function () {
    [].forEach.call(document.querySelectorAll('[data-mm-bed]'), function (root) {
      var data = dataFor(root); if (data) { restore(root, data); showNote(root, ''); }
    });
  });
})();
